import { RbacFeature } from '@evidentid/tprm-portal-lib/models/rbac';

export const UI_COMBINED_FEATUERS = [
    {
        label: 'Add, edit, pause, unpause, or deactivate an entity',
        features: [
            RbacFeature.dashboardAddAndEditEntity,
            RbacFeature.entityDetailsEditProperties,
            RbacFeature.dashboardPauseEntity,
            RbacFeature.dashboardActivateDeactivateEntity,
        ],
    },
    {
        label: 'Create or copy a submission link',
        features: [
            RbacFeature.dashboardCreateNewLink,
            RbacFeature.dashboardCopySubmissionLink,
        ],
    },
    {
        label: 'View and edit branding settings, contact information, email configurations, and settings',
        features: [
            RbacFeature.displayAndEmailBrandingSettings,
            RbacFeature.displayAndEmailContactInformation,
            RbacFeature.displayAndEmailContent,
            RbacFeature.displayAndEmailSettings,
        ],
    },
    {
        label: 'View a risk profile and assignments',
        features: [
            RbacFeature.decisioningViewRiskProfile,
            RbacFeature.decisioningViewRiskProfiles,
            RbacFeature.decisioningViewEntitiesAssigned,
        ],
    },
    {
        label: 'Add, edit, delete, or save a risk profile',
        features: [
            RbacFeature.decisioningCreateRiskProfile,
            RbacFeature.decisioningDeleteRiskProfile,
            RbacFeature.decisioningEditRiskProfile,
            RbacFeature.decisioningManageAssignmentRules,
            RbacFeature.decisioningManageCriteria,
            RbacFeature.decisioningManageEvaluationRules,
            RbacFeature.decisioningSaveRiskProfileChanges,
        ],
    },
];
